import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Icon from 'components/Icon';

import styles from './styles.module.scss';

export const InfoContainer = ({ children, isShow, onHandleClick }) => {
	const [iconStatus, setIconStatus] = useState(false);
	if (!isShow) {
		return <div className={styles.infoContainer}>{children}</div>;
	}

	const hoverStatus = iconStatus
		? 'audio-infoButton-hover'
		: 'audio-infoButton-default';

	return (
		<div className={styles.infoContainer}>
			{children}
			<button
				type="button"
				className={styles.infoButton}
				onClick={onHandleClick}
				onFocus={() => setIconStatus(true)}
				onMouseOver={() => setIconStatus(true)}
				onMouseLeave={() => setIconStatus(false)}
			>
				<Icon icon={hoverStatus} />
			</button>
		</div>
	);
};

InfoContainer.propTypes = {
	children: PropTypes.node.isRequired,
	onHandleClick: PropTypes.func.isRequired,
	isShow: PropTypes.bool.isRequired
};
